import { render, staticRenderFns } from "./honor_month_week.vue?vue&type=template&id=b442e134&"
import script from "./honor_month_week.vue?vue&type=script&lang=js&"
export * from "./honor_month_week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports